/**
 * Created by Xuz on 2019/07/16.
 * xuz@live.cn
 * 重写 Vue 版流程编辑器
 *
 * Xuz on 2020/01
 * 正式开工
 */
import * as WFC from './WFConstants'
import WFHelper from './WFHelper'
import WFToolBar from './WFToolBar'
import WFObject from './WFObject'
import WFNode from './WFNode'
import WFLink from './WFLink'
import WFXml from './WFXml'
import WFDocWalker from './WFDocWalker'
import TBChoicer from './toolbar/TBChoicer'
import TBStartNode from './toolbar/TBStartNode'
import TBCreateNode from './toolbar/TBCreateNode'
import TBEndNode from './toolbar/TBEndNode'
import TBRepeat from './toolbar/TBRepeat'
import TBLinker from './toolbar/TBLinker'
import TBTransEnd from './toolbar/TBTransEnd'
import { SVG } from '@svgdotjs/svg.js'
import WFRepeat from '@/views/workflow/design/editor/js/WFRepeat'
import WFTracker from './WFTracker'

var iMouseDblTime = 300 // SVG本身不支持鼠标双击事件，这里使用简单的模拟来实现

var sXLinkns = 'http://www.w3.org/2000/xlink/namespace/'

let aWF_SYS_MSG = []
aWF_SYS_MSG['#header'] = '注意:'
aWF_SYS_MSG['#time'] = 5000
aWF_SYS_MSG['startnode.onlyone'] = '一个流程只允许且必须只能存在一个起点'
aWF_SYS_MSG['repeater.exist'] = '此对象已经有一个自循环'
aWF_SYS_MSG['road.exist'] = '指向该点已经存在连接，连接将不会被创建'
aWF_SYS_MSG['repeater.only.commonnode'] = '状态点、起点、结束点、子流程都不允许创建循环'
aWF_SYS_MSG['startnode.notlink'] = '起点不能做为任何通道的结束点'
aWF_SYS_MSG['startnode.onlyone.allow'] = '起点只能连接至一个普通节点'
aWF_SYS_MSG['startnode.onlycan.link.common'] = '起点不能连接至子流、终点、状态点'
aWF_SYS_MSG['activity.notlinkable'] = '状态点、结束点、子流程都不能向外做路径的连接'

class WorkFlow {
  _init () {
    this.options = {
      procId: null,
      mode: WFC.WF_OPERATION_ADD,
      force: false,
      state: WFC.WF_PROCESS_STATE_EDITING
    }

    this.wfDocWalker = null
    this.wfXml = null
    // 存放工具条实例
    this.aToolbar = []
    // 保存所有SVG实例，包括activity与其它各种JS封装类
    this.aElement = []
    // 保存所有的在SVG上的_activity实例
    this.aActivitys = []
    this.aRoads = []
    this.oSvgJs = null
    this.dSvgDocument = null
    this.CTM = null

    // 当前激活toolbar的id
    this.sCurrentToolBar = null
    this.dLastActiveElement = null

    this.iMouseCount = 0
    this.bDrawLink = false
    this.bMouseDowning = false

    this.parent = null
    this.op = null
    this.bDrawLink = false
    // 新添加工具条的位置偏移
    this.iTbX = 0
    this.iTbY = 0

    this.mouseTracker = null

    this.wfObject = null
    this.startNode = null

    // 开始监控是否有新元素增加
    this.bStartWatch = false
    // 是否有新元素增加
    this.bRegChanged = false

    this.iInfoEnterTime = 0
    this.iInfoLastTime = 0
    this.sInfoTimeout = null

    WFHelper.resetNamesIndex()
  }

  constructor (parent, svgId, svgContent, options) {
    this._init()
    this.options = Object.assign(this.options, options)
    this.parent = parent

    this.wfXml = new WFXml(this)
    this.wfDocWalker = new WFDocWalker(this)

    this.oSvgJs = SVG('#' + svgId)
    if (svgContent) {
      this.oSvgJs.svg(svgContent)
    }

    this.dSvgDocument = this.oSvgJs.node

    this.CTM = this.dSvgDocument.getScreenCTM()

    this.wfDocWalker.visit(this.oSvgJs)

    const that = this
    // 初始化事件
    this.oSvgJs.mousedown(event => that.onMouseDown(event))
    this.oSvgJs.mouseup(event => that.onMouseUp(event))

    document.getElementById('WFContainer').onkeydown = function (e) {
      let keyCode = e.keyCode
      switch (keyCode) {
        case 46: // Delete
          that.onRemoveLastElement(e)
          break
      }
    }

    this.addToolBar('TBChoicer', new TBChoicer(this))

    if (this.isEditMode()) {
      this.addToolBar('TBStartNode', new TBStartNode(this))
    }

    this.addToolBar('TBCreateNode', new TBCreateNode(this))
    this.addToolBar('TBEndNode', new TBEndNode(this))
    this.addToolBar('TBRepeat', new TBRepeat(this))
    this.addToolBar('TBLinker', new TBLinker(this))
    this.addToolBar('TBTrans', new TBTransEnd(this))

    // 默认显示选择器
    this.activeToolBar('TBChoicer')

    // 如果是跟踪模式隐藏工具栏
    if (this.options.mode === WFC.WF_OPERATION_TRACKER) {
      this.hideToolBar()
      this.wfTracker = new WFTracker(this)
      this.wfTracker.onLoad()
    }

    // 创建流程总定义类
    if (this.wfObject == null) {
      this.wfObject = new WFObject(this)
      this.wfObject.create()
    }

    // 如果是编辑模式还需要读取其定义的xml文档做参数设置
    if (this.getMode() !== WFC.WF_OPERATION_ADD) {
      this.wfXml.unSerial(this.options.procId)
    }
  }

  onLocate (from, to) {
    this.wfTracker.locate(from, to)
  }

  updateSvg (svg) {
    this.oSvgJs.svg(svg)
  }

  addToolBar (id, clazz) {
    let t = new WFToolBar()
    t.create(this, id, clazz, this.iTbX, this.iTbY)
    this.aToolbar[id] = t

    this.iTbY += WFC.iToolbarHeight
  }

  selectToolBar (event) {
    if (event.button !== 0) {
      return
    }

    event.stopPropagation()

    // 正在拖动时不能使用其它按钮
    if (this.bMouseDowning) {
      return
    }

    let dToolBar = SVG(event.target)
    dToolBar = WFHelper.getReal(dToolBar, 'nodeId', 'ToolBar')
    let tId = dToolBar.attr('tbType')
    this.activeToolBar(tId)
  }

  activeToolBar (tId) {
    if (this.sCurrentToolBar != null) {
      this.aToolbar[this.sCurrentToolBar].onUnSelect()
    }
    this.sCurrentToolBar = tId
    this.aToolbar[this.sCurrentToolBar].onSelect()

    // 当工具条改变时其会出发SVG上所有的对象的相应事件
    for (let i in this.aElement) {
      if (this.aElement[i] != null) {
        this.aElement[i].onToolbarChange(tId)
      }
    }
  }

  hideToolBar () {
    this.oSvgJs.find('#ToolBarContainer').hide()
  }

  onMouseDown (event) {
    event.preventDefault()
    // console.log('onMouseDown')
    if (event.button !== 0) {
      event.preventDefault()
    }
    // 正在拖动时不能使用其它按钮
    if (this.bMouseDowning) {
      return
    }

    if (event.button !== 0) {
      event.preventDefault()

      // 如果当前选择的对象是线条，则触发修改线条类型的操作
      let bUseOp = false
      let el = this.aElement[WFHelper.getSelectedElementId(event)]
      if (el != null) {
        if (el instanceof WFLink) {
          el.nextType()
          bUseOp = true
          return
        }
      }
      if (!bUseOp) {
        // 使用非左键时就自动将工具条放至选择器
        this.activeToolBar('TBChoicer')
        // 取消正选择中的对象
        this.setUnSelectLastElement(event)
        return
      }
    }

    event.stopPropagation()
    this.bMouseDowning = true
    if (this.sCurrentToolBar == null) {
      return
    }

    // 模拟双击，svg.js的双击事件在连接加入了outline后，双击无法触发
    if (this.iMouseCount >= 1) {
      this.bMouseDowning = false
      this.iMouseCount = 0
      window.clearTimeout(this.mouseTracker)
      this.publishEvent(event, 'doMouseDblClick')
      return
    }

    this.iMouseCount++
    const that = this
    this.mouseTracker = window.setTimeout(function () {
      that.mouseClickTracker()
    }, iMouseDblTime)

    this.publishEvent(event, 'doMouseDown')
  }

  onMouseUp (event) {
    event.preventDefault()
    if (event.button !== 0) {
      event.preventDefault()
      return
    }
    event.stopPropagation()
    this.bMouseDowning = false
    if (this.sCurrentToolBar == null) {
      return
    }
    // console.log('onMouseUp')
    this.publishEvent(event, 'doMouseUp')
  }

  /**
   * 鼠标移动，只会在鼠标按下时才执行各个操作
   */
  onMouseMove (event) {
    event.preventDefault()
    // 忽略右键
    if (event.button !== 0) {
      event.preventDefault()
      return
    }
    if (!this.bMouseDowning) {
      return
    }
    event.stopPropagation()
    if (this.sCurrentToolBar == null) {
      return
    }
    this.publishEvent(event, 'doMouseMove')
  }

  onMouseDblClick (event) {
    this.publishEvent(event, 'doMouseDblClick')
  }

  publishEvent (event, eventType) {
    let instance = this.aToolbar[this.sCurrentToolBar].getController()
    switch (eventType) {
      case 'doMouseDown':
        instance.doMouseDown(event)
        break
      case 'doMouseMove':
        instance.doMouseMove(event)
        break
      case 'doMouseUp':
        instance.doMouseUp(event)
        break
      case 'doMouseDblClick':
        instance.doMouseDblClick(event)
        break
      default:
        alert('不支持的分派事件:' + eventType)
    }
  }

  doMouseDblClick (event) {
    let el = this.getLastElement()
    if (el == null) {
      return
    }
    el.onMouseDblClick(event)
  }

  getParent () {
    return this.parent
  }

  getWfXml () {
    return this.wfXml
  }

  getSvgJs () {
    return this.oSvgJs
  }

  getCTM () {
    return this.CTM
  }

  getMode () {
    return this.options.mode
  }

  /**
   * 检查当前的定义中的模式是否编辑中模式，编辑中模式是全功能开放的，其它的状态都将被限制各种功能的使用
   */
  isEditMode () {
    if (this.options.force === true) { // 强制编辑模式
      return true
    }
    if (this.options.state === WFC.WF_PROCESS_STATE_EDITING) {
      return true
    }
    return false
  }

  setMessage (msgKey) {
    this.iInfoEnterTime = new Date().getTime()
    if (this.iInfoEnterTime - this.iInfoLastTime < 1000) {
      return
    }
    if (this.sInfoTimeout != null) {
      this.clearMessage()
    }
    if (msgKey == null) {
      this.parent.setMessage('')
    } else {
      this.parent.setMessage(aWF_SYS_MSG['#header'] + aWF_SYS_MSG[msgKey])
      const that = this
      this.sInfoTimeout = window.setTimeout(function () {
        that.clearMessage()
      }, aWF_SYS_MSG['#time'])
    }
    this.iInfoLastTime = this.iInfoEnterTime
  }

  clearMessage () {
    if (this.sInfoTimeout != null) {
      window.clearTimeout(this.sInfoTimeout)
      this.sInfoTimeout = null
      this.parent.setMessage('')
    }
  }

  isMouseDowning () {
    return this.bMouseDowning
  }

  /**
   * 设置总定义类
   */
  setWFObject (wfObject) {
    this.wfObject = wfObject
  };

  getWFObject () {
    return this.wfObject
  }

  /*
   * 设置流程起点
   */
  setStartNode (el) {
    this.startNode = el
  }

  /*
   *
   * 获得流程起点
   */
  getStartNode () {
    return this.startNode
  }

  /**
   * 获得结点集合
   */
  getEndNodes () {
    let tmp = []
    for (let i in this.aActivitys) {
      let activity = this.aActivitys[i]
      if (activity.getType() === WFC.NODE_TYPE_END_NODE) {
        tmp.push(activity)
      }
    }
    return tmp
  }

  /**
   * 获得转换节点集合
   */
  getTransNodes () {
    let tmp = []
    for (let i in this.aActivitys) {
      let activity = this.aActivitys[i]
      if (activity.getType() === WFC.NODE_TYPE_TRANS_NODE) {
        tmp.push(activity)
      }
    }
    return tmp
  }

  /**
   * 获得某个节点的所有外连接
   */
  getNodeRoadsOut (nodeUuid) {
    let allRoutes = this.aRoads[nodeUuid]
    let outs = []
    if (allRoutes != null) {
      for (let i = 0; i < allRoutes.length; i++) {
        let r = allRoutes[i]
        if (r == null) {
          continue
        }
        // 起点是自己就是连接出去的路径
        if (r.getStart() === nodeUuid) {
          outs.push(r)
        }
      }
    }
    return outs
  }

  /**
   * 获得所有纸质送件节点
   */
  getPaperNodes () {
    let tmp = []
    for (let i in this.aActivitys) {
      let activity = this.aActivitys[i]
      if (activity.getFlowType() === 'P') {
        tmp[activity.uuid()] = activity
      }
    }
    return tmp
  }

  getActivities () {
    return this.aActivitys
  }

  setDrawLink (isDraw) {
    this.bDrawLink = isDraw
  }

  isDrawLink () {
    return this.bDrawLink
  }

  /*
   * 取消选择的最后一个对象，这其实会委托调用最后一个对象的onUnSelect方法
   */
  setUnSelectLastElement (event) {
    const el = this.getLastElement()
    if (el == null) {
      return
    }
    el.onUnSelect(event)
    this.setLastElement(null)
  }

  /**
   * 保存前需要进行的操作
   */
  onBeforeSave () {
    this.activeToolBar('TBCreateNode')
  }

  /**
   * 获得一个注册的JS组件
   */
  getElement (uuid) {
    return this.aElement[uuid]
  }

  /*
   * 获得用户选择的对象，是JS包装过的SVG对象
   */
  getSelectedElement (event) {
    return this.aElement[WFHelper.getSelectedElementId(event)]
  }

  moveLinkers (uuid) {
    let links = this.aRoads[uuid]
    if (links == null || links.length === 0) {
      return
    }
    for (let i = 0; i < links.length; i++) {
      if (links[i] != null) {
        links[i].relateMove(uuid)
      }
    }
  }

  /**
   * 获得节点所拥有的路径
   */
  getNodeRoads (nodeUuid) {
    return this.aRoads[nodeUuid]
  }

  /*
   * 选中一个对象，委托调用对象的onSelect方法
   */
  setActiveElement (el, event) {
    this.setUnSelectLastElement(event)
    el.onSelect(event)
    this.setLastElement(el)
  }

  /*
   * 获得最后一个被选择的对象
   */
  getLastElement () {
    return this.dLastActiveElement
  }

  onRemoveLastElement (event) {
    // 流程跟踪模式不允许删除元素
    if (this.options.mode === WFC.WF_OPERATION_TRACKER) {
      return
    }

    let lastEl = this.getLastElement()
    if (lastEl == null) {
      return
    }
    if (this.isEditMode()) {
      // 正常删除
      lastEl.remove()
    } else {
      // 在非编辑模式时检查这个元素是否属于已经定义的元素，如果为原始元素就判断是否按下了shift
      // 非原始对象，直接可以删除
      if (!lastEl.isSrc()) {
        lastEl.remove()
        return
      }
      // 如果是原始对象，但是没有按下shift
      if (lastEl.isSrc() && !event.shiftKey) {
        alert('这是原流程当中的对象，不能删除，只有新增加对象才能删除！')
        this.setUnSelectLastElement()
        return
      }
      if (lastEl.isSrc() && event.shiftKey) {
        if (!confirm('您启用了特殊操作[强制删除对象功能]请确认删除不会造成流程错误才使用该功能，确认吗？')) {
          return
        }
        lastEl.remove()
      }
    }
  }

  /*
   * 设置最后一个被选择的JS对象
   */
  setLastElement (el) {
    this.dLastActiveElement = el
  }

  getOverNode (event) {
    let pos = WFHelper.getPos(event, this.getCTM())
    let el = null
    for (let i in this.aActivitys) {
      el = this.aActivitys[i]
      if (WFHelper.isInBound(pos, WFHelper.getBound(el.getSvg()))) {
        return el
      }
    }
    return null
  }

  setRoad (startElId, endElId, linker) {
    this.addRoad(startElId, linker)
    this.addRoad(endElId, linker)
  }

  /**
   * 删除关联路径
   */
  clearRoad (startElId, endElId, linker) {
    this.removeRoad(startElId, linker)
    this.removeRoad(endElId, linker)
  }

  /**
   * 添加一个连接路径
   */
  addRoad (elId, linker) {
    if (this.aRoads[elId] == null) {
      this.aRoads[elId] = []
    }
    this.aRoads[elId].push(linker)
  }

  /**
   * 删除一条连接路径
   */
  removeRoad (elId, linker) {
    let roadLinkers = this.aRoads[elId]
    if (roadLinkers == null) {
      return
    }
    for (let i = 0; i < roadLinkers.length; i++) {
      if (roadLinkers[i] === linker) {
        delete roadLinkers[i]
      }
    }
  }

  /**
   * 获得整个流程的所有路径
   */
  getRoads () {
    return this.aRoads
  }

  /**
   * 检查指定的路径是否已经建立
   */
  isRoadCreated (startElId, endElId) {
    if (this.getRoad(startElId, endElId) == null) {
      return false
    }
    return true
  }

  /**
   * 获得指定路径
   */
  getRoad (startElId, endElId) {
    let linkers = this.aRoads[startElId]
    if (linkers == null) {
      return null
    }
    for (let i = 0; i < linkers.length; i++) {
      if (linkers[i] != null) {
        if (linkers[i].isRoad(startElId, endElId)) {
          return linkers[i]
        }
      }
    }
    return null
  }

  registerElement (inst) {
    if (this.bStartWatch) {
      this.bRegChanged = true
    }

    if (inst instanceof WFNode) {
      const type = inst.getType() * 1
      switch (type) {
        case WFC.NODE_TYPE_COMMON_NODE:
          break
        case WFC.NODE_TYPE_START_NODE:
          this.setStartNode(inst)
          break
      }
      this.aActivitys[inst.uuid()] = inst
      // 登记XML的定义
      this.wfXml.addActivity(inst)
    } else if (inst instanceof WFLink) {
      // Linker的登记在其本身完成
    } else if (inst instanceof WFRepeat) {
      this.wfXml.addRepeat(inst)
    } else if (inst instanceof WFObject) {
      this.wfXml.addObject(inst)
    }

    this.aElement[inst.uuid()] = inst
  }

  /**
   * 取消注册一个组件，当一个对象从黑板上消失时，也需要取消
   */
  unregisterElement (inst) {
    if (inst instanceof WFNode) {
      let type = inst.getType() * 1
      switch (type) {
        case WFC.NODE_TYPE_COMMON_NODE:
          break
        case WFC.NODE_TYPE_START_NODE:
          this.setStartNode(null)
          break
        case WFC.NODE_TYPE_END_NODE:
          break
      }
      delete this.aActivitys[inst.uuid()]
      this.wfXml.removeActivity(inst)
    } else if (inst instanceof WFLink) {
      this.wfXml.removeRoute(inst)
    } else if (inst instanceof WFRepeat) {
      this.wfXml.removeRepeat(inst)
    }

    delete this.aElement[inst.uuid()]
    inst = null
  }

  /**
   * 将一个SVG对象提前其位置，不被其它SVG对象覆盖
   */
  bringToFront (wfElement) {
    this.oSvgJs.add(wfElement)
  }

  /**
   * 双击处理复位
   */
  mouseClickTracker () {
    this.iMouseCount = 0
  }
}

export default WorkFlow
